var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ace79896dc1e1f4e4b2f2df2e51de9192820ac27"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@higher-learning-technologies"]={id:"ace79896dc1e1f4e4b2f2df2e51de9192820ac27"};
      